const MainContent = ({ children }) => (
  <main className="container-fluid px-0 bg-secondary" >{children}</main>
);

export default MainContent;  